import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Button } from 'antd';
import { FaEye, FaTrash, FaEyeSlash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { setMealVisibility } from '../../../store/meals/actions';
import { getSettingsState } from '../../../store/settings/selector';

import { MealContext } from './MealDetails';
import { DeleteModal } from './DeleteMeal';
import { GlobalModalHandler } from '../../layout/GlobalModal';
import { VisibilityModal } from './VisibilityModal';

export const ActionButtons: React.FC = () => {
  const { meal, onPressDelete } = React.useContext(MealContext);
  const { preferences } = useSelector(getSettingsState);
  const dispatch = useDispatch();
  const history: History = useHistory();
  const handleEyeBtnPress = () => {
    if (meal?.visible && preferences.mealInvisibleMessage) {
      const content = <VisibilityModal meal={meal} />;
      GlobalModalHandler({ content });
      return;
    }
    const body = { mealid: meal?.id, visible: !meal?.visible };
    dispatch(setMealVisibility(body));
  };

  const deleteMeal = () => {
    const content = <DeleteModal onPressDelete={onPressDelete} />;
    GlobalModalHandler({ content });
  };

  const editMeal = () => {
    history.push({
      pathname: '/meal/edit',
      state: meal,
    });
  };

  return (
    <Col className="action-buttons-container">
      <div className="action-button-wrapper">
        <Button type="link" onClick={handleEyeBtnPress}>
          {!meal?.visible ? (
            <FaEyeSlash size={22} color="#8dc63f" />
          ) : (
            <FaEye size={22} color="#8dc63f" />
          )}
        </Button>
        <Button type="link" onClick={deleteMeal}>
          <FaTrash size={16} color="#8dc63f" />
        </Button>
        <Button type="link" onClick={editMeal}>
          <GoPencil size={18} color="#8dc63f" />
        </Button>
      </div>
    </Col>
  );
};
